module.exports = function() {
  return new Worker(__webpack_public_path__ + "e399a907eabae72acb9f.worker.js");
};